export const OUTSTANDING_TOOL_REQUEST = "OUTSTANDING_TOOL_REQUEST";
export const OUTSTANDING_TOOL_SUCCESS = "OUTSTANDING_TOOL_SUCCESS";
export const OUTSTANDING_TOOL_FAIL = "OUTSTANDING_TOOL_FAIL";
